import Axios from '@/Axios'

class AcitvityLogService {
    async getActivityLogs(data = {}) {
        return await Axios.get('wms.wms.api.activity_log.get_activity_logs', {params : data})
    }

    async getActivityLog(logId) {
        return await Axios.get('wms.wms.api.activity_log.get_activity_log_by_id', { params: { log_id: logId } })
    }
}
export default new AcitvityLogService()
